import ToastProviderImport from './ToastContext/ToastProvider';
import ToastConsumerImport from './ToastContext/ToastConsumer';
import withToastImport from './ToastContext/withToast';

export const ToastProvider = ToastProviderImport;
export const ToastConsumer = ToastConsumerImport;
export const withToast = withToastImport;